module.exports = __webpack_public_path__ + "61df8111ddaf350aac86c9a384e27175.svg";